<template>

    <form id="form-reservation" class="form-reservation">
        <div id="form-reservation-anchor" class="form-reservation-anchor"></div>
        <div class="reservation-form" ref="reservationCard">
            <div class="title-header">
                Reservering
            </div>

            <!-- Selected locations -->
            <div class="date">
                <div class="nested-lg">
                    <div class="col-md-50 col-padding-lg" v-if="reservation.date !== null">
                        Van <strong>{{reservation.date[0]}}</strong> {{reservation.date[1]}} <strong>{{reservation.date[2]}}</strong>
                        <a class="edit" @click="change(true)" style="cursor: pointer">Wijzigen</a>
                    </div>

                    <div class="col-md-50 col-padding-lg">
                        <strong>Voorkeur:</strong> <span v-for="(location, index) of reservation.locations">{{location.title}}<span v-if="index < (reservation.locations.length-1)">, </span></span>
                        <a class="edit" style="cursor: pointer" @click="change(false)">Wijzigen</a>
                    </div>
                </div>
            </div>

            <div class="extra-info">

                <div v-for="(location, index) of reservation.locations">

                    <div class="nested-lg extra-info-item">

                        <div class="col-lg-100 col-padding-lg title">Locatie: {{location.title}}</div>

                        <!-- Num persons -->
                        <div class="col-lg-50 col-padding-lg">

                            <div class="subtitle">Aantal personen</div>

                            <div class="nested">
                                <div class="col-xs-55 col-sm-40 col-md-30 col-lg-55 col-padding">
                                    Personen <span>(12+ jaar)</span>
                                </div>

                                <div class="col-xs-45 col-sm-60 col-md-70 col-lg-45 col-padding">
                                    <div class="add-number">
                                        <template v-if="location.type === 'pipo_home' || location.type === 'rental_mobile_home'">
                                            <i class="icon icon-squared-minus" @click="location.persons.adults > 1 ? location.persons.adults-- : null"></i>
                                            <input
                                                type="number"
                                                class="form-control form-sm"
                                                placeholder="1"
                                                v-model="location.persons.adults"
                                            >
                                            <i class="icon icon-squared-plus" @click="location.persons.adults < 2 ? location.persons.adults++ : null"></i>
                                        </template>
                                        <template v-else>
                                            <i class="icon icon-squared-minus" @click="location.persons.adults > 1 ? location.persons.adults-- : null"></i>
                                            <input
                                                type="number"
                                                class="form-control form-sm"
                                                placeholder="1"
                                                v-model="location.persons.adults"
                                            >
                                            <i class="icon icon-squared-plus" @click="location.persons.adults++"></i>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <!-- Exception - do not show when locationType is "accomodation" or "pipo_home" -->
                            <div v-if="location.type !== 'accommodation' && location.type !== 'pipo_home' && location.type !== 'rental_mobile_home'">
                                <div class="nested">
                                    <div class="col-xs-55 col-sm-40 col-md-30 col-lg-55 col-padding">
                                        Kinderen <span>(3 tot 11 jaar)</span>
                                    </div>

                                    <div class="col-xs-45 col-sm-60 col-md-70 col-lg-45 col-padding">
                                        <div class="add-number">
                                            <i class="icon icon-squared-minus" @click="location.persons.children > 0 ? location.persons.children-- : null"></i>
                                            <input type="number" name="" class="form-control form-sm" v-model="location.persons.children">
                                            <i class="icon icon-squared-plus" @click="location.persons.children++"></i>
                                        </div>
                                    </div>
                                </div>

                                <!-- Exception - do not show when locationType is "accomodation" or "pipo_home" -->
                                <div class="nested">
                                    <div class="col-xs-55 col-sm-40 col-md-30 col-lg-55 col-padding">
                                        Kinderen <span>(0 tot 2 jaar)</span>
                                    </div>

                                    <div class="col-xs-45 col-sm-60 col-md-70 col-lg-45 col-padding">
                                        <div class="add-number">
                                            <i class="icon icon-squared-minus" @click="location.persons.babies > 0 ? location.persons.babies-- : null"></i>
                                            <input type="number" name="" class="form-control form-sm" v-model="location.persons.babies">
                                            <i class="icon icon-squared-plus" @click="location.persons.babies++"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Exception - do not show when locationType is "accomodation" or "pipo_home" or "rental_mobile_home" -->
                        <div class="col-lg-50 col-padding-lg extra" v-if="pricing !== null && location.type !== 'accommodation' && location.type !== 'pipo_home' && location.type !== 'rental_mobile_home'">
                            <div class="subtitle">Extra opties</div>

                            <div class="nested">
                                <div class="col-xs-55 col-sm-40 col-md-30 col-lg-55 col-padding">
                                    Huisdieren <span>(&euro;{{pricing.pet}})</span>
                                </div>

                                <div class="col-xs-45 col-sm-60 col-md-70 col-lg-45 col-padding">
                                    <div class="add-number">
                                        <i class="icon icon-squared-minus" @click="location.options.pet > 0 ? location.options.pet-- : null"></i>
                                        <input type="number" name="" class="form-control form-sm" v-model="location.options.pet">
                                        <i class="icon icon-squared-plus" @click="location.options.pet++"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="nested" v-if="location.has_tent === '1'">
                                <div class="col-xs-55 col-sm-40 col-md-30 col-lg-55 col-padding">
                                    Extra kleine tenten <span>(&euro;{{pricing.extra_tent}})</span>
                                </div>
                                <div class="col-xs-45 col-sm-60 col-md-70 col-lg-45 col-padding">
                                    <div class="add-number">
                                        <i class="icon icon-squared-minus" @click="location.options.extra_tent > 0 ? location.options.extra_tent-- : null"></i>
                                        <input type="number" name="" class="form-control form-sm" v-model="location.options.extra_tent">
                                        <i class="icon icon-squared-plus" @click="location.options.extra_tent++"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="nested" v-if="location.has_power === '1'">
                                <div class="col-xs-55 col-sm-40 col-md-30 col-lg-60 col-padding">
                                    Stroom (6 ampère) <span>(&euro;{{pricing.power}})</span>
                                </div>
                                <div class="col-xs-45 col-sm-60 col-md-70 col-lg-40 col-padding">
                                    <label class="radio-parent">
                                        <input class="check-control" type="radio" value="1" v-model.number="location.options.power">
                                        <div class="radio-placeholder form-lg"></div>
                                        Ja
                                    </label>
                                    <label class="radio-parent">
                                        <input class="check-control" type="radio" value="0" v-model.number="location.options.power">
                                        <div class="radio-placeholder form-lg"></div>
                                        Nee
                                    </label>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </div>

            <!-- Global overview -->
            <div class="total-price">
                <div class="nested-lg">
                    <div class="col-md-50 col-padding-lg">
                        <strong>Totale prijs</strong> voor {{reservation.dayCount}} overnachtingen
                        <div class="small" v-if="this.hasRentalLocation === false">Incl. één auto, één tent/caravan/camper/accommodatie + extra opties</div>
                    </div>

                    <div class="col-md-50 col-padding-lg price-bold">
                        <span v-if="priceOriginal !== null" style="text-decoration: line-through; font-size: 0.7em; padding-right: 20px;">{{priceOriginal}} </span>
                        <span>{{price}}</span>
                    </div>

                </div>
            </div>

            <!-- Reservation form -->
            <div class="form-details" style="clear: both;">

                <div class="subtitle">Uw gegevens</div>
                <div class="form-input">
                    <div class="nested-lg">
                        <div class="col-sm-50 col-padding-lg">
                            <label>Volledige naam*</label>
                            <input class="form-control form-block" type="text" v-model="customer.name" required tabindex="1">
                        </div>

                        <div class="col-sm-50 col-padding-lg">
                            <label>Geboortedatum*</label>
                            <input class="form-control form-block" type="text" v-model="customer.birthdate" required tabindex="5">
                        </div>
                    </div>

                    <div class="nested-lg">
                        <div class="col-sm-50 col-padding-lg">
                            <label>Telefoonnummer*</label>
                            <input class="form-control form-block" type="text" v-model="customer.phone" required tabindex="2">
                        </div>

                        <div class="col-sm-50 col-padding-lg">
                            <label>E-mailadres*</label>
                            <input class="form-control form-block" type="text" v-model="customer.email" required tabindex="6">
                        </div>
                    </div>

                    <div class="nested-lg">
                        <div class="col-sm-50 col-padding-lg">
                            <label>Adres*</label>
                            <input class="form-control form-block" type="text" v-model="customer.address" required tabindex="3">
                        </div>

                        <div class="col-sm-50 col-padding-lg">
                            <label>Postcode*</label>
                            <input class="form-control form-block" type="text" v-model="customer.zip" required tabindex="7">
                        </div>
                    </div>

                    <div class="nested-lg">
                        <div class="col-sm-50 col-padding-lg">
                            <label>Stad*</label>
                            <input class="form-control form-block" type="text" v-model="customer.city" tabindex="4">
                        </div>

                        <div class="col-sm-50 col-padding-lg">
                            <label>Land*</label>
                            <select class="form-control form-block" v-model="customer.country">
                                <option value="be">België</option>
                                <option value="nl">Nederland</option>
                                <option value="lu">Luxembourg</option>
                                <option value="de">Deutschland</option>
                                <option value="fr">France</option>
                                <option value="es">Spain</option>
                                <option value="it">Italy</option>
                                <option value="pt">Portugal</option>
                                <option value="at">Austria</option>
                                <option value="dk">Denmark</option>
                                <option value="se">Sweden</option>
                                <option value="fi">Finland</option>
                                <option value="ie">Ireland</option>
                                <option value="hr">Croatia</option>
                                <option value="cz">Czech Repulic</option>
                                <option value="pl">Poland</option>
                                <option value="si">Slovenia</option>
                                <option value="sk">Slovakia</option>
                                <option value="uk">UK</option>
                            </select>
                        </div>
                        <div class="col-sm-100 col-padding-lg">
                            <label>Opmerking</label>
                            <textarea class="form-control form-block" v-model="customer.note" tabindex="9"></textarea>
                        </div>

                    </div>
                </div>



                <div class="subtitle">Betaling</div>
                <div class="form-input">

                    <div class="nested-lg">
                        <div class="col-sm-100 col-padding-lg">
                            <label>Hoe wilt u betalen *</label>
                            <div v-for="paymentType of paymentTypes">
                                <input type="radio" v-model="customer.payment_method_type" :id="paymentType.id" :value="paymentType.id">
                                <label :for="paymentType.id">{{ paymentType.description}}</label>
                            </div>
                        </div>
                        <div v-if="customer.payment_method_type === 'pay_online'" class="col-sm-50 col-padding-lg">
                            <label>Selecteer uw betaalmethode *</label>
                            <select v-model="customer.payment_method" class="form-control form-block">
                                <option v-for="paymentMethod of paymentMethodsMollie" :value="paymentMethod.id">{{ paymentMethod.description }}</option>
                            </select>
                        </div>
                        <div v-if="customer.payment_method_type === 'pay_gift_card'">
                            <div class="col-sm-50 col-padding-lg">
                                <label>Selecteer uw cadeaubon *</label>
                                <select v-model="customer.gift_card_type" class="form-control form-block">
                                    <option v-for="giftCard of giftCardTypes" :value="giftCard.id">{{ giftCard.description }}</option>
                                </select>
                            </div>
                            <div class="col-sm-50 col-padding-lg">
                                <label>Cadeaubon bedrag *</label>
                                <input type="number" v-model="customer.gift_card_amount" class="form-control form-block"/>
                            </div>
                            <div class="form-details">
                                <div class="warning-text">
                                    <p><strong>Let op:</strong> als het cadeaubon bedrag lager is dan de totale prijs dan zal u aan de receptie het restbedrag moeten betalen.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="nested-lg">
                        <div class="col-sm-100 col-padding-lg">
                            <a class="btn btn-primary btn-block" @click="makeReservation()">Versturen</a>
                        </div>
                    </div>


                </div>


                <div class="warning-text">
                    <p><strong>Let op:</strong> u geeft aan ons een voorkeur door. Het is (nog) niet definitief dat u deze plek(ken) toegewezen krijgt.</p>
                </div>
            </div>
        </div>

    </form>

</template>

<script>
    import {EventBus} from "../event-bus";

	export default {
		name: "ReservationFormComponent",
        data() {
		    return {
		        picker: null,
                pricing: null,
                reservation: {
					dayCount: 0,
					date: null,
					locations: null,
				},
                customer: {
                    name: null,
                    phone: null,
                    address: null,
                    city: null,
                    birthdate: null,
                    email: null,
                    zip: null,
                    country: null,
                    note: null,
                    payment_method_type: null,
                    payment_method: null,
                    gift_card_type: null,
                    gift_card_amount: null,
                },
                price: 0,
                pricePretty: null,
                priceOriginal: null,
                hasDiscount: null,
                hasRentalLocation: false,

                paymentTypes: null,
                paymentMethodsMollie: null,
                giftCardTypes: null,

                debug: false,
            }
        },
        watch: {
			'reservation': {
				handler: function () {
					this.calculatePrice();
				},
				deep: true
			}
        },
		methods: {
			calculatePrice() {
				axios({
				    method: 'POST',
				    url: 'ajax/calc-price',
				    data: {
						'reservation': this.reservation,
				    },
				})
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }
                    this.price = response.data.pricePretty;
                    this.priceOriginal = response.data.priceOriginalPretty;
                    this.hasDiscount = response.data.hasDiscount;
                })
                .catch(e => {
                    this.$swal("Oeps!", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de reservering. Probeer het later opnieuw.", "error");
                });
            },
		    change(resetDate) {
		        this.$swal({
                    title: "Weet je het zeker?",
                    text: "Bij het uitvoeren van deze actie worden de voorkeursplaatsen gereset. Geen zorgen, de andere waarden blijven wel staan.",
                    showCancelButton: true,
                    cancelButtonText: "Annuleren",
                    confirmButtonText: "Ja"
                })
                .then(confirm => {
                     if (confirm.isConfirmed) {
                         window.scrollTo({
                             top: 0,
                             behavior: 'smooth'
                         });
                         this.$refs.reservationCard.style.display = 'none';

                         EventBus.$emit('reset', resetDate);
                     }
                });
            },
            makeReservation() {
                axios({
                    method: 'POST',
                    url: 'ajax/save-reservation',
                    data: {
						reservation: this.reservation,
						customer: {
							name: this.customer.name,
							phone: this.customer.phone,
							address: this.customer.address,
							city: this.customer.city,
							birthdate: this.customer.birthdate,
							email: this.customer.email,
							zip: this.customer.zip,
							country: this.customer.country,
							note: this.customer.note,
                            payment_method_type: this.customer.payment_method_type,
                            payment_method: this.customer.payment_method,
                            gift_card_type: this.customer.gift_card_type,
                            gift_card_amount: this.customer.gift_card_amount,
						}
					}
                })
                .then(response => {
                    if (response.data.status === 200) {
                    	if (response.data.redirectUrl) {
							window.location.href = response.data.redirectUrl;
                        }
                    }
                    if (response.data.status === 400) {
                        throw [true, response.data.message];
                    }
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het maken van de reservering. Probeert u het later normaals.", "error");
                });
            },
		},
        mounted() {
		    EventBus.$on('create-reservation', (locations, date, picker) => {
		        // Set the date picker so it can be used
                this.picker = picker;

		        // Make the reservation card visible
                let reservationCard = this.$refs.reservationCard;
                reservationCard.style.display = 'block';
                const formReservation = document.getElementById('form-reservation-anchor');
				formReservation.scrollIntoView({
                    block: "start",
                    behavior: "smooth"
                });

                // Set the reservation data
                this.reservation.locations = locations;
                this.reservation.date = date.split(" ");

                // Exception, check if at least one location is pipo_home or rental_mobile_home
                Object.entries(this.reservation.locations).forEach(([key, location]) => {
                    if (location.type !== undefined && (location.type === 'pipo_home' || location.type === 'rental_mobile_home')) {
                        this.hasRentalLocation = true;
                    }
                })

                // Calculate the amount of days for the booking
                let startDateSplit = this.reservation.date[0].split('-');
                let endDateSplit = this.reservation.date[2].split('-');
                let startDate = new Date(startDateSplit[2], startDateSplit[1]-1, startDateSplit[0]);
                let endDate = new Date(endDateSplit[2], endDateSplit[1]-1, endDateSplit[0]);
                let timeDiff = endDate.getTime() - startDate.getTime();
                this.reservation.dayCount = Math.round(timeDiff / (1000 * 3600 * 24));

                // Get payment types/methods/gift cards
                axios.get('ajax/get-payment-data?start='+this.reservation.date[0]+'&end='+this.reservation.date[2])
                    .then(response => {
                        this.paymentTypes = response.data.paymentTypes;
                        this.paymentMethodsMollie = response.data.paymentMethodsMollie;
                        this.giftCardTypes = response.data.giftCardTypes;

                        if (this.paymentTypes.length === 1) {
                            this.customer.payment_method_type = 'pay_online';
                        }
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de betaalmethodes. Probeert u het later normaals.", "error");
                    });
            });

			// Debug
			if (this.debug === true) {
				this.customer = {
					name: 'Ballasthoeve Test',
					phone: '+31 6 54 874 558',
					address: 'Piushaven 3',
					city: 'Tilburg',
					birthdate: '4 april 80',
					email: 'franklin@beinter.nl',
					zip: '5017 AN',
					country: 'de',
					note: 'Mijn opmerkingen.',
			    };
			}

			axios.get('ajax/get-customer-data')
            .then(response => {
                let customerData = response.data.customerData;
                if (customerData !== null) {
                    this.customer = {
                        name: customerData.name,
                        phone: customerData.phone,
                        birthdate: customerData.birthdate,
                        email: customerData.email,
                        address: customerData.address,
                        zip: customerData.zip,
                        city: customerData.city,
                        country: customerData.country,
                        note: customerData.note,
                        payment_method: customerData.payment_method,
                    };
                }
            })
            .catch(() => {
            });


			// Get the pricing from the config
			axios.get('ajax/get-pricing')
            .then(response => {
                this.pricing = response.data;
            })
            .catch(() => {
                this.$swal("Oeps!", "Er is iets mis gegaan bij het ophalen van de prijzen. Probeer het later nog een keer.", "error");
            });

        }

    }


</script>

<style scoped>
    .form-reservation {
        position: relative;
    }

    .form-reservation-anchor {
        position: absolute;
        top: -20px;
        left: 0;
    }

    .reservation-form {
        display: none;
    }

    .icon-squared-minus {
        cursor: pointer;
    }

    .icon-squared-plus {
        cursor: pointer;
    }

    .title {
        background-color: #eee;
        font-weight: bold;
        padding: 5px 20px;
    }
</style>
